module.exports = __webpack_public_path__ + "static/media/skeletal.6187b624.ogg";